import {
  GET_SALES_REPORT_LIST_REQUEST,
  GET_SALES_REPORT_LIST_SUCCESS,
  GET_SALES_REPORT_LIST_FAILURE,
} from "actions/report";

const initialState = {
  loading: false,
  error: {},
  list: [],
  totalCount: 0,
};

export default function report(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_SALES_REPORT_LIST_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_SALES_REPORT_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        list: payload.map((it, i) => {
          return {
            ...it,
            id: i,
          };
        }),
        totalCount: payload.length,
      };
    }

    case GET_SALES_REPORT_LIST_FAILURE: {
      return {
        ...state,
        loading: false,
      };
    }

    default:
      return state;
  }
}
